import { forwardRef, HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

export type ContainerProps = HTMLAttributes<HTMLDivElement>

const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, ...props }, ref) => {
    return <div ref={ref} className={cn('container', className)} {...props} />
  }
)

export default Container
